@if (model$ | async; as model) {
    <div class="reward-token-card__top-combined">
        <div class="reward-token-card__header-combined">
            <div class="reward-token-card__title reward-token-card__title-combined">{{ model.title }}</div>
            <div class="acca-boost-card__winnings">
                @if (model.originalWinnings && model.boostedWinnings) {
                    <div class="acca-boost-card__old-winnings" [@oldValueAnimation]="model.originalWinnings">
                        {{ model.originalWinnings | bsCurrency: true }}
                    </div>
                    <div
                        [ngClass]="'acca-boost-card__new-winnings' + (accaBoostConfig.isEnhancedLayoutEnabled ? '-enhanced' : '')"
                        [@newValueAnimation]="model.boostedWinnings">
                        {{ model.boostedWinnings | bsCurrency: true }}
                    </div>
                } @else {
                    <div class="acca-boost-card__empty-winnings">{{ null | bsCurrency: true }}</div>
                }
            </div>
        </div>
        <!-- TODO: this works by chance as Object.values for arrays basically returns the array -->
        <bs-reward-token-categories [categories]="$any(getTokenCategories(model))" />
    </div>
    <bs-reward-token-limitations [limitations]="getTokenLimitations(model)" />
}
